import React, { Component, useLayoutEffect } from "react";
import styles from "./Bank.module.css";
import { connect } from "react-redux";

import { Page } from "../../../helbest";

import { bank_cancel_text } from "../../../base/env";

import ERROR from "../../../assets/images/base/cancel.png";
import Button from "../../components/ui/Button";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

function CancelBank(props) {
  const navigate = useLangNavigate();

  useLayoutEffect(() => {
    if (!props.Login.is_login) {
      navigate("/");
    }
  }, []);

  return (
    <Page
      className="page-bank"
      title="Payment Result"
      back={true}
      address="/"
      customHeader={<HeaderBack url={"/"} title={"Payment Result"} />}
      showFooter
      mobileContainer
      headerFix
      logo
    >
      <div className="container desktop-mode">
        <div className={`box-page ${styles.Box}`}>
          <div className="text-center">
            <img className="payment-img" src={ERROR} alt="" />
            <br />
            <br />
            <h4 className="red">Your payment is canceled</h4>
            <br />
          </div>
          <br />
          <div
            dangerouslySetInnerHTML={{
              __html: bank_cancel_text,
            }}
          />
          <br />
          <div className="w-full flex center-content">
            <Button
              onClick={() => navigate("/")}
              style_width={"100%"}
              style={{ maxWidth: "200px" }}
            >
              Home Page
            </Button>
          </div>
        </div>
      </div>
    </Page>
  );
}

const mstp = (state) => ({
  Login: state.Login,
  Cart: state.Cart,
});
export default connect(mstp)(CancelBank);
